import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.REFUND_SET_REFUND_LIST]: (state, payload) => {
    state.refundList = payload.refundList
  }
}

export default Mutations
